<template>
  <div class="lucky-draw-grid">
    <div
      v-for="(item,index) in prizeList"
      :key="index"
      :class="{[activeClass]: activeIndex === item.aniIndex,[prizeClass]:true}"
      @click="clickPrize"
    >
      <slot
        name="prize"
        :item="item"
        :index="index"
      >
        {{ item.name }}
      </slot>
    </div>

    <slot
      name="pointer"
      :is-drawing="isDrawing"
    >
      <div
        class="draw-button"
        :class="{'disabled':isDrawing}"
        @click="play"
      >
        {{ btnText }}
      </div>
    </slot>
  </div>
</template>

<script>
import { RangeLoop } from '@/utils/lottery'
import { props } from '@/utils/lottery-props'

export default {
  name: 'NineGrid',
  props: {
    ...props,
  },
  data() {
    return {
      rangeLoopInstance: null,
      isDrawing: false, // 是否正在抽奖
      activeIndex: -1, // 中奖索引
      endCallback: null,
    }
  },
  computed: {
    prizeList() {
      return this.prizes.map((item, index) => {
        return {
          ...item,
          aniIndex: item.aniIndex ?? index,
        }
      })
    },
  },
  methods: {
    reset() {
      this.rangeLoopInstance?.reset()
      this.activeIndex = -1
      this.isDrawing = false
    },
    play() {
      if (this.isDrawing) {
        this.$emit('rotating')
        return
      }
      if (this.animation) {
        if (!this.rangeLoopInstance) {
          this.rangeLoopInstance = new RangeLoop({
            range: [0, this.prizes.length], // 奖品索引范围
            speed: this.speed, // 速度
            factor: this.factor, // 阻尼系数
            loop: this.loop, // pick执行时多转一圈
            watchValue: (value) => {
              // 运功开始时绑定number，驱动页面动画
              this.activeIndex = Math.floor(value)
            },
            endCallback: (val) => {
              //  结束回调
              const prizeData = this.prizes.find((item, index) => item.aniIndex === val)
              this.$emit('end', prizeData)
              typeof this.endCallback === 'function' && this.endCallback(prizeData)
              this.rangeLoopInstance.reset(false)
              this.isDrawing = false
            },
          })
        }
        this.isDrawing = true
        this.rangeLoopInstance.play()
      }
      this.$emit('start')
    },

    pick(index, endCallback) {
      this.endCallback = endCallback // 保存结束回调
      if (this.animation) {
        this.rangeLoopInstance.pick(index)
      } else {
        this.activeIndex = index
        const prizeData = this.prizes.find((item, index) => item.aniIndex === val)
        this.$emit('end', prizeData)
        typeof endCallback === 'function' && endCallback(prizeData)
      }
    },

    clickPrize(item) {
      this.$emit('clickPrize', item)
    },
  },
}
</script>

<style>
.active{
  color: YELLOW;
}
</style>
